import React, {useState} from 'react';
import MapTableInterface from '../components/forms/MapTableInterface.js';
import DatePicker from "react-datepicker";
import Box from '../components/ui/Box.js';

import api from '../api/index.js';

export default (props) => {
	
	const [processor, setProcessor] = useState(props.processor);
	const [date, setDate] = useState(props.date);
	const [fakedate, setFakeDate] = useState('2020-08-16');
	
	return <div>
	<MapTableInterface 
			maptable="processors" 
			value={processor} 
			name="processor" 
			onChange={(e)=>{console.log("Change", e.target.value); setProcessor(e.target.value.value)}} 
		/>
		<DatePicker
				id="date"
				selected={date}
				onChange={(e)=>setDate(e)}
			/>
		<button onClick={(e)=>setFakeDate(date.api())}>Cache</button>
		<input type="text" value={fakedate} onChange={(e)=>setFakeDate(e.target.value)} />
		<button onClick={(e)=>setDate(api.date(fakedate))}>Restore</button>
	</div>;
}
